module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/4/4-e210c19b5f10b3357ee2da84f6b5b2a4.jpg";